import React from 'react';
import { Button, Divider, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { RangePicker } from './RangePicker';
import styles from '../UserActions.module.scss';

export const DateRangeFilter = ({
  selectedKeys,
  setSelectedKeys,
  confirm,
  close,
  onApply,
  onReset,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.box}>
      <Space direction="vertical" size={12}>
        <RangePicker
          selectedKeys={selectedKeys}
          setSelectedKeys={dates => setSelectedKeys(dates || [])}
        />
      </Space>
      <Divider className={styles.divider} />
      <div className={styles.wrapButton}>
        <Button
          size="small"
          onClick={() => {
            setSelectedKeys([]);
            onReset();
            confirm();
          }}
        >
          {t('userActions.reset')}
        </Button>
        <Button
          size="small"
          type="primary"
          onClick={() => {
            const range = selectedKeys && selectedKeys.length === 2 ? selectedKeys : [];
            onApply(range);
            close();
            confirm();
          }}
        >
          {t('userActions.choose')}
        </Button>
      </div>
    </div>
  );
};
